<template>
  <div>
    <v-list dense nav>
      <template v-for="item in items">
        <v-list-group
          :key="item.name"
          v-model="item.meta.active"
          :prepend-icon="item.action"
          no-action
          :group="item.path"
          v-if="item.meta.operator"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            dense
            v-for="subItem in item.children"
            :key="subItem.meta.nameDrawer"
            :to="{ name: subItem.name }"
            v-show="subItem.meta.operator"
            v-model="item.meta.active"
          >
            <v-list-item-content>
              <v-list-item-title
                v-text="subItem.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
    <v-divider></v-divider>
    <v-list v-if="exemptedPlayer.has_exempt_player" shaped dense>
      <v-list-item @click="loginExemptedPlayer">
        <v-list-item-icon>
          <v-icon>mdi-account-eye</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("loginExemptPlayer") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list shaped dense>
      <v-list-item
        :to="{
          name: 'bigTable',
        }"
      >
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("goToWebsite") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <BtnLanguages class="pa-2" />
  </div>
</template>

<script>
import BtnLanguages from "@/components/btn-languages/btn-languages.vue";
import RouterAgent from "@/views/dashboard/agent/router.config.js";
export default {
  name: "drawerList",
  components: {
    BtnLanguages,
  },
  data: () => ({
    items: RouterAgent,
  }),

  watch: {
    credit() {
      this.handleRouteHiding();
    },
  },

  computed: {
    innerSport() {
      return this.$store.state.innerSport;
    },
    retail() {
      return this.$store.state.operators.retail;
    },
    credit() {
      return this.$store.state.operators.credit;
    },
    affiliateLevel() {
      return this.$store.state.logged.data.is_afilliate;
    },
    exemptedPlayer() {
      return this.$store.state.exemptedPlayer;
    },
  },
  async mounted() {
    await this.handleRouteHiding();
  },

  methods: {
    loginExemptedPlayer() {
      this.$axios.get("agent/affiliates/exemptPlayerLogin").then((resp) => {
        const loginUserData = resp.data;

        let url = this.$store.state.operators.url;

        var lastChar = url.substr(-1);
        if (lastChar != "/") {
          url = url + "/";
        }

        const splitByHttps = url.split("https://");

        let www = "";
        if (!url.includes("www.")) {
          www = "www.";
        }

        url = "https://" + www + splitByHttps[1];

        const loginData = {
          token_jwt: loginUserData.token_jwt,
          token_exp: loginUserData.token_exp,
          user_data: loginUserData.user_data,
        };

        window.open(
          url + `?loginExemptPlayer=${JSON.stringify(loginData)}`,
          "_blank"
        );
      });
    },
    hasExemptedPlayer() {
      this.$axios
        .get("agent/affiliates/hasExemptedPlayer")
        .then((resp) => {
          this.$store.commit("setExemptedPlayer", resp.data.dados);
        })
        .catch(() => {});
    },
    handleRouteHiding() {
      let affiliateLevel = this.affiliateLevel;

      // Verify if this affiliate has exempted player
      this.hasExemptedPlayer();

      this.items.forEach((route) => {
        const hideAffiliatesTransfers = affiliateLevel == 0 || this.credit != 2;

        if (route.name === "AgentBet" || route.name === "AgentDashboard") {
          if (this.retail == 0) {
            route.meta.operator = false;
          }
        }

        if (route.name === "AffiliatesTransfers") {
          route.meta.operator = !hideAffiliatesTransfers;
        }

        // Retail 1 e 0
        if (route.name == "AgentCredit") {
          if (this.credit == 2) {
            route.meta.operator = false;
          } else if (this.retail != 2) {
            route.meta.operator = false;
          }
        }

        // Retail 1 e 0
        if (route.name == "AgentFinancial" && this.retail != 2) {
          route.meta.operator = false;
        }

        // ONLY agent
        if (route.name == "AgentCampaigns" && affiliateLevel == 0) {
          route.meta.operator = false;
        }
        
        if (route.name == "AgentReports" && affiliateLevel == 0) {
          route.meta.operator = false;
        }

        // ONLY affiliate
        if (route.name == "AgentDashboard" && affiliateLevel == 1) {
          route.meta.operator = false;
        }
        // ONLY affiliate
        if (route.name == "AgentBet" && affiliateLevel == 1) {
          route.meta.operator = false;
        }
        // ONLY affiliate
        if (route.name == "AgentCredit" && affiliateLevel == 1) {
          route.meta.operator = false;
        }
        // Retail 2
        else if (route.name == "AgentFinancialSimplified" && this.retail == 2) {
          route.meta.operator = false;
        }

        route.children.forEach((child) => {
          // Retail 1 e 0
          if (child.name == "AgentBetPay" && this.retail != 2) {
            child.meta.operator = false;
          }
          if (child.name == "AgentFinancialCommissionsSimplified") {
            if (this.retail == 1 && this.credit == 0) {
              child.meta.operator = false;
            } else if (this.credit == 1) {
              child.meta.operator = false;
            }
          }

          if (child.name == "AgentSellCredit") {
            const retail2AndCredit1 = this.retail == 2 && this.credit == 1;
            if (!retail2AndCredit1) {
              child.meta.operator = false;
            }
          }
          // ONLY agent
          if (child.name == "AgentFinancialCommissions") {
            if (affiliateLevel == 0 || this.credit != 2) {
              child.meta.operator = false;
            }
          }

          if (
            child.name == "AgentFinancialCommissionsSimplified" &&
            affiliateLevel == 0
          ) {
            child.meta.operator = false;
          }
          if (child.name == "ListAffiliatesSimplified") {
            if (affiliateLevel == 0 || this.credit == 1) {
              child.meta.operator = false;
            }
          }

          // // ONLY agent
          if (child.name == "ListAffiliates") {
            if (affiliateLevel == 0 || this.credit != 2) {
              child.meta.operator = false;
            }
          }

          if (
            child.name == "AgentFinancialCommissionsSimplified" &&
            affiliateLevel == 0
          ) {
            child.meta.operator = false;
          }

          if (child.name == "ListAffiliatesSimplified") {
            if (affiliateLevel == 0 || (this.retail == 1 && this.credit == 0)) {
              child.meta.operator = false;
            }
          }
          
          if (
            child.name == "AgentFinancialCommissionsSimplified" &&
            affiliateLevel == 0
          ) {
            child.meta.operator = false;
          }

          if (child.name == "ListAffiliatesSimplified" && affiliateLevel == 0) {
            child.meta.operator = false;
          }

          // ONLY affiliate
          if (child.name == "AgentFinancialExtract" && affiliateLevel == 1) {
            child.meta.operator = false;
          }
          // ONLY affiliate
          if (child.name == "AgentFinancialExtractSimplified") {
            if (affiliateLevel == 1 || this.retail == 0) {
              child.meta.operator = false;
            }
          }
        });
      });
    },
  },
};
</script>
